<script> 
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";  
import satdosyazarfacmakontrol from "@/models/satdosyazarfacmakontrol";
import zarfacmavebelgekontroltutanagi from "./zarfacmavebelgekontroltutanagi.vue"; 
export default {
  props: ["satdosyaId"],
  mixins: [apibtoast, apigeneric, satdosyazarfacmakontrol],
  page: {
    title: "Firmalar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader, 
    zarfacmavebelgekontroltutanagi 
  },
  data() {
    return {
      title: this.$t("ofirma.Title"),
      items: [
        {
          text: this.$t("ofirma.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("ofirma.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("ofirma.Title"),
          active: true,
        },
      ],
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData:{},
      DefaultPage: 1,
      FormData: {},
      AddEdit:"",
      zarfacmakontrol:{},
      Istenilenbelgeler:"",
      Istenilenbelgelers:"",
      satdosya:{}
    
    };
  },
  methods: {
    Get() {

      this.ActionsSingleGet({
        Service: "satdosya", 
        Id: this.satdosyaId,
      }).then((res) => {
        this.satdosya = res.Data;
      });


       this.ActionsFilterGet({"Service":"satdosyazarfacmakontrol", "Page":this.Page,"Filter":"&Dosyaid="+this.satdosyaId}).then((ressatdosyazarfacmakontrol) => {
         if(ressatdosyazarfacmakontrol){
         this.zarfacmakontrol = ressatdosyazarfacmakontrol.Data; 
        
     

       this.ActionsFilterGet({"Service":"satdosyafirma", "Page":this.Page,"Filter":"&Dosyaid="+this.satdosyaId+"&Firmaturu=3"}).then((ressatdosyafirma) => {
        if(ressatdosyafirma){
        this.TableData = ressatdosyafirma.Data;
        this.Page.PageDataSize = ressatdosyafirma.TotalCount;  
         
    
       this.ActionsFilterGet({"Service":"satdosyaihaleilani", "Page":this.Page,"Filter":"&Dosyaid="+this.satdosyaId}).then((res) => {
         this.Istenilenbelgeler = res.Data[0].Istenilenbelgeler; 
         this.Istenilenbelgelers = res.Data[0].Istenilenbelgelers; 
          for(var i=0; i<this.TableData.length; i++)
          { 
            
            this.FormData.[this.TableData[i].Id]={} 
             if(this.zarfacmakontrol){ 
                let ArrayFilter = this.zarfacmakontrol.filter((notification) =>
                  notification.Dosyafirmaid.includes(this.TableData[i].Id)
                );  
                  if(ArrayFilter.length == 0){
                      for(var j=0; j<this.Istenilenbelgeler.length; j++)
                      { 
                      this.FormData.[this.TableData[i].Id].[this.Istenilenbelgeler[j]]=0
                      }
                }
                 else{ 
                   this.FormData.[this.TableData[i].Id] = JSON.parse(ArrayFilter[0].Istenilenbelgeler)
                } 
              } 
          }  
      });  
      }
      });
      }
      });
 
    },
    onSubmit(FirmaId) {   
       if(this.zarfacmakontrol){
       var zarfacmakontrolu = this.zarfacmakontrol.filter((notification) => 
        notification.Dosyafirmaid.includes(FirmaId)
      );   
      } 
           let FormData={
            Dosyaid : this.satdosyaId,
            Dosyafirmaid : FirmaId,
            Istenilenbelgeler : JSON.stringify(this.FormData[FirmaId])
          } 
        if (zarfacmakontrolu.length == 0 || this.zarfacmakontrol.length == 0) {   
          
          this.Post("satdosyazarfacmakontrol", FormData); 
          this.Get();
        } else {  
          FormData.Id=zarfacmakontrolu[0].Id 
          this.Update("satdosyazarfacmakontrol", FormData);  
        } 
    },
    SatDosyaUpdate(){  
          this.Update("satdosya", this.satdosya);  
    }
  },
};
</script>

<template>
  <Loader>
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body"> 
              <div class="row mb-2">
            <div class="col-sm-3">    
                <b-form-input 
                  v-model="satdosya.Zarfbelgekontroltutanaktarih"
                  id="date" 
                  type="datetime-local" 
                  @input="SatDosyaUpdate()"
                ></b-form-input>
             </div> 
            <div class="col-sm-9">
              <div class="text-sm-end">
                <button
                  type="button"
                  class="btn btn-success btn-rounded mb-2 me-2"
                  v-b-modal.zarfacmavebelgekontroltutanagi
                >
                  <i class="mdi mdi-file-export-outline me-1"></i>
                  {{
                    $t(
                      "satdosyazarfacmakontrol.Page.zarfacmavebelgekontroltutanagi"
                    )
                  }}
                </button>
              </div>
            </div> </div>

            <div class="table-responsive">  
              <table class="table mb-0">
                <thead class="table-light">
                  <tr>
                    <th>{{ $t("satdosyazarfacmakontrol.Table.Firmaadi") }}</th>
                    <th
                      scope="row"
                      v-for="(Belgeler, index) in Istenilenbelgelers"
                      :key="index"
                    >
                      {{ Belgeler }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="Data in TableData" :key="Data.Id">
                    <th scope="row">{{ Data.Firmaadi }}</th>
                    <td
                      v-for="(Belgeler, index) in Istenilenbelgeler"
                      :key="index"
                    >
                      <select
                        class="form-select"
                        type="text"
                        v-model="FormData[Data.Id][Belgeler]"
                        @change="onSubmit(Data.Id)"
                      >
                        <option value="">{{ $t('OrtakKullanim.seciniz')}}</option>
                        <option value="1">VAR</option>
                        <option value="2">YOK</option>
                        <option value="3">UYGUN DEĞİL</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
              <br />
              <b-pagination
                class="pagination pagination-rounded justify-content-end mb-2"
                v-model="DefaultPage"
                :total-rows="Page.PageDataSize"
                :per-page="Page.PageSize"
                aria-controls="my-table"
                @input="ChangePage(DefaultPage)"
              >
              </b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <zarfacmavebelgekontroltutanagi 
    :satdosyaId="satdosyaId" 
    :Zarfbelgekontroltutanaktarih="satdosya.Zarfbelgekontroltutanaktarih" />
  </Loader>
</template>
